import React, { ReactNode } from 'react';

import ConfigContext from './context/ConfigContext';

import { config } from 'config/config';

type Props = { children: ReactNode };

const ConfigContextProvider = ({ children }: Props) => {
	return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export default ConfigContextProvider;
